import React from 'react'
import PropTypes from 'prop-types'
import {
  AccountType,
  AppliedDiscountCodeType,
  BillingType,
  ContactType,
  MembershipType,
  ProductPrices,
} from 'types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { ApplicationSteps, MembershipSummary } from 'member-portal/components'
import { selectors as memberSelectors } from 'member-reducer'
import {
  MEMBER_APPLICATION_STEP_LINKS,
  PATH,
  makeMemberApplicationPath,
  makeMemberApplicationApplyPath,
} from 'config'

const propTypes = {
  account: AccountType,
  billing: BillingType,
  contact: ContactType,
  children: PropTypes.node.isRequired,
  discountCodeDetails: AppliedDiscountCodeType,
  isTrialMembershipsActive: PropTypes.bool,
  membership: MembershipType,
  membershipPrices: ProductPrices.isRequired,
  promoCodeIsTrial: PropTypes.bool.isRequired,
  selectedMembershipType: PropTypes.string.isRequired,
  selectedTrailerCareType: PropTypes.string,
  trailerCarePrices: ProductPrices.isRequired,
  trialDuration: PropTypes.number,
}

function MemberApplicationLayout({
  account,
  billing,
  contact,
  children,
  discountCodeDetails,
  isTrialMembershipsActive,
  membership,
  membershipPrices,
  promoCodeIsTrial,
  selectedMembershipType,
  selectedTrailerCareType,
  trailerCarePrices,
  trialDuration,
}) {
  const { pathname } = useLocation()

  const updateLink = makeMemberApplicationPath(PATH.MEMBERSHIP_TYPE_SELECTED)

  const completeMemberApplicationStepLinks = [
    ...MEMBER_APPLICATION_STEP_LINKS,
    {
      stepName:
        isTrialMembershipsActive && promoCodeIsTrial
          ? 'Credit Card Information'
          : 'Payment',
      path: makeMemberApplicationApplyPath(PATH.PAYMENT),
      stepIcon: '/assets/images/icons/with-background/ST_YIcon_Payment.svg',
    },
  ]

  return (
    <div className="form-with-aside-wrapper">
      <header className="header-title">
        <h1>Become a Sea Tow Member</h1>
      </header>
      <div className="form-with-aside-block">
        <div className="form-with-aside">
          <ApplicationSteps
            pathname={pathname}
            stepLinks={completeMemberApplicationStepLinks}
            account={account}
            billing={billing}
            contact={contact}
            membership={membership}
          >
            {children}
          </ApplicationSteps>
          <div className="update-link">
            {updateLink && promoCodeIsTrial && isTrialMembershipsActive
              ? ''
              : updateLink && (
                <Link to={updateLink} className="link-primary">
                  Change Membership Selections
                </Link>
              )}
          </div>
        </div>
        <aside>
          <MembershipSummary
            donation={billing && billing.finalDonation}
            membershipType={selectedMembershipType}
            trailerCareType={selectedTrailerCareType}
            updateLink={updateLink}
            {...{
              discountCodeDetails,
              membershipPrices,
              trailerCarePrices,
            }}
            {...(isTrialMembershipsActive && {
              promoCodeIsTrial,
              trialDuration,
            })}
          />
        </aside>
      </div>
    </div>
  )
}

MemberApplicationLayout.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: memberSelectors.account(state),
    billing: memberSelectors.billing(state),
    contact: memberSelectors.contact(state),
    discountCodeDetails: memberSelectors.discountCodeDetails(state),
    isTrialMembershipsActive: memberSelectors.isTrialMembershipsActive(state),
    membership: memberSelectors.membership(state),
    membershipPrices: memberSelectors.membershipPrices(state),
    promoCodeIsTrial: memberSelectors.promoCodeIsTrial(state),
    selectedMembershipType: memberSelectors.selectedMembershipType(state),
    selectedTrailerCareType: memberSelectors.selectedTrailerCareType(state),
    trailerCarePrices: memberSelectors.trailerCarePrices(state),
    trialDuration: memberSelectors.trialDuration(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  MemberApplicationLayout,
)
